// import ratingApi from './dev';  // dev
import ratingApi from './prod'; // prod

export default ratingApi;
